import React, { useState, useRef, useEffect } from 'react'
import FlexComponent from '../FlexComponent'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { RadioButton } from 'primereact/radiobutton'
import { ErrorMessage, Field, FieldArray } from 'formik'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { Checkbox } from 'primereact/checkbox'
import './form.css'
import { Country, State, City } from 'country-state-city';
import { Divider } from 'primereact/divider'
import { MultiSelect } from 'primereact/multiselect'

function WhatTypeOfHome({ values, formName = "", errors, touched, handleBlur, handleChange, setFieldValue }) {
    const [areaIndex, setAreaIndex] = useState()
    const [areaCity, setAreaCity] = useState()
    const [areaState, setAreaState] = useState()
    const [tempAddress, setTempAddress] = useState('');
    const areaStreetRef = useRef('');
    const addressInputRef = useRef(null);
    const autocompleteRef = useRef(null);

    // console.log("state", areaState)
    // console.log("city", areaCity)

    useEffect(() => {
        if (window.google && window.google.maps && addressInputRef.current && !autocompleteRef.current) {
            if (!addressInputRef.current || !(addressInputRef.current instanceof HTMLInputElement)) return;
            autocompleteRef.current = new window.google.maps.places.Autocomplete(addressInputRef.current, {
                types: ['geocode'],
                componentRestrictions: { country: 'us' },
            });

            autocompleteRef.current.addListener('place_changed', () => {
                const place = autocompleteRef.current.getPlace();
                let state = '';
                let city = '';
                let streetNumber = '';
                let route = '';
                place.address_components?.forEach((component) => {
                    const types = component.types;
                    if (types.includes('street_number')) {
                        streetNumber = component.long_name;
                    }
                    if (types.includes('route')) {
                        route = component.long_name;
                    }
                    if (types.includes('locality') ||
                        types.includes('sublocality') ||
                        types.includes('sublocality_level_1') ||
                        types.includes('neighborhood')) {
                        city = component.long_name;
                    }
                    if (types.includes('administrative_area_level_1')) {
                        state = component.short_name;
                    }
                });

                areaStreetRef.current = [streetNumber, route].filter(Boolean).join(' ');
                setTempAddress(place.formatted_address || '');
                setAreaState(state);
                setAreaCity(city);
            });
        }
    }, []);

    const handleSelectAll = () => {
        const allOptions = ["1 Family", "2 Family", "3+ / Multi-Family", "Condo", "Co-op"];
        setFieldValue('home_type', allOptions);
    };

    const handleDeselectAll = () => {
        setFieldValue('home_type', []);
    };

    const handleAddClick = () => {
        // setLoading(true)
        let prior = false
        if (values.specific_area_interested_in?.length === 0) {
            prior = true
        }
        values.specific_area_interested_in.push({
            street_address: areaStreetRef.current,
            state: State.getStateByCodeAndCountry(areaState, 'US')?.name,
            city: areaCity,
            priority: prior
        });

        setAreaIndex(values.specific_area_interested_in.length - 1)
        areaStreetRef.current = '';
        setAreaState('')
        setAreaCity('')
        setTempAddress('');
    };

    useEffect(() => {
        if (areaState) {
            handleAddClick()
        }

    }, [areaState])
    // console.log(values)

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id='homeTypeId'>
            {/* <div style={{ background: '#08113A' }}>
                {(values.file_status === "Accepted Offer" || values.file_status === "In Contract") ? <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', color: 'white' }}>What is the Subject property address?</p>
                    : <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', color: 'white' }}>What type of home are you looking for?</p>
                }
            </div> */}
            <div >
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', fontFamily: "Barlow Semi Condensed" }}>What type of home are you looking for?</p>
            </div>

            {(formName === "New Loan Set Up App" && (values.file_status === "Accepted Offer" || values.file_status === "In Contract")) && (
                <div className='inputContainerDiv' style={{ width: '100%', margin: "1.5rem 0" }}>
                    <label htmlFor="subject_property_address" style={{ fontWeight: 'bold' }}>Subject Property Address</label>
                    <Field rows={4} type="text" id="subject_property_address" name="subject_property_address" as={InputTextarea} style={{ width: '100%' }} />
                </div>
            )}
            <div style={{ textAlign: 'start', padding: "0.75rem" }}>
                <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start'>
                    <div className='inputContainerDiv' style={{ width: '35%' }}>
                        <div>
                            <MultiSelect
                                value={values.home_type}
                                options={[
                                    { label: '1 Family', value: '1 Family' },
                                    { label: '2 Family', value: '2 Family' },
                                    { label: '3+ / Multi-Family', value: '3+ / Multi-Family' },
                                    { label: 'Condo', value: 'Condo' },
                                    { label: 'Co-op', value: 'Co-op' },
                                ]}
                                style={{ width: '100%', color: 'black' }}
                                // onChange={(event) => handleChange('home_type')(event.value)}
                                onChange={(event) => handleChange({ target: { name: 'home_type', value: event.value } })}
                                placeholder='Home Type'
                            // filter
                            />
                        </div>
                    </div>


                    <div className='inputContainerDiv' style={{ width: '25%' }}>
                        <Dropdown
                            id='bedrooms'
                            value={values.bedrooms}
                            options={[
                                { label: "1", value: "1" },
                                { label: "2", value: "2" },
                                { label: "3", value: "3" },
                                { label: "4", value: "4" },
                                { label: "5+", value: "5+" },
                            ]}
                            style={{ width: '100%' }}

                            onChange={(e) => {
                                // handleChange('bedrooms')(e.value)
                                handleChange({
                                    target: {
                                        name: `bedrooms`,
                                        value: e.value
                                    }
                                })
                            }}
                            showClear={values.bedrooms}
                            onBlur={handleBlur}
                            placeholder='Bedrooms?'
                        // filter
                        />
                    </div>

                    <div className='inputContainerDiv' style={{ width: '20%' }}>
                        <Dropdown
                            id='bathrooms'
                            value={values.bathrooms}
                            options={[
                                { label: "1", value: "1" },
                                { label: "2", value: "2" },
                                { label: "3", value: "3" },
                                { label: "4", value: "4" },
                                { label: "5", value: "5" },
                            ]}
                            style={{ width: '100%' }}

                            onChange={(e) => {
                                // handleChange('bathrooms')(e.value)
                                handleChange({
                                    target: {
                                        name: `bathrooms`,
                                        value: e.value
                                    }
                                })
                            }}
                            showClear={values.bathrooms}
                            onBlur={handleBlur}
                            placeholder='Bathrooms?'
                        // filter
                        />
                    </div>

                    <div className='inputContainerDiv' style={{ width: '45%' }}>
                        {/* <label htmlFor="do_you_have_price_range_in_mind" style={{ fontWeight: 'bold' }}>Do you have a price range in mind?</label> */}
                        <Field type="number" id="do_you_have_price_range_in_mind" placeholder="Do you have a price range in mind?"
                            name="do_you_have_price_range_in_mind" as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />
                    </div>

                    <div className='inputContainerDiv' style={{ width: '30%' }}>
                        <Dropdown
                            id='purchase_type'
                            value={values.purchase_type}
                            options={[
                                { label: "Home to live in", value: "Home to live in" },
                                { label: "Investment Property", value: "Investment Property" },
                            ]}
                            style={{ width: '100%' }}

                            onChange={(e) => {
                                // handleChange('purchase_type')(e.value)
                                handleChange({
                                    target: {
                                        name: `purchase_type`,
                                        value: e.value
                                    }
                                })
                            }}
                            showClear={values.purchase_type}
                            onBlur={handleBlur}
                            placeholder='Purchase Type'
                        // filter
                        />
                    </div>

                </FlexComponent>

                <FlexComponent justifyContent='center'>
                    <div style={{ width: '100%' }}>
                        <div style={{ width: '100%', textAlign: 'start', margin: '0.5rem' }}>
                            <label htmlFor="specific_area_interested_in" >
                                <p style={{ fontWeight: 'bold' }}>Where are you looking?</p><span>(include as many areas of interest as they would like or just choose the state if they dont know what city)</span>
                            </label>
                        </div>
                        {/* <FlexComponent></FlexComponent> */}

                        {/* <FieldArray name="specific_area_interested_in">
                            {(arrayHelpers) => ( */}
                        <FlexComponent className='inputFlexContainer' gap='1rem' alignItems='start' justifyContent='start'>
                            <div className='inputContainerDiv' style={{ width: '50%', margin: '0.5rem 0.5rem 0 0.5rem' }}>
                                <InputText
                                    ref={addressInputRef}
                                    style={{ width: '100%' }}
                                    value={tempAddress}
                                    onChange={(e) => setTempAddress(e.target.value)}
                                    placeholder="Search for an address in the area you're interested in"
                                    onBlur={handleBlur}
                                />
                            </div>
                            {/* <div className='inputContainerDiv' style={{ width: '25%', margin: '0.5rem 0.5rem' }}>
                                <Field
                                    name={`areaState`}
                                >{({ field }) => (
                                    <Dropdown
                                        id={field.name}
                                        value={areaState}
                                        options={State.getStatesOfCountry('US')?.map((state) => ({
                                            label: state.name,
                                            value: state.isoCode,
                                        })) || []}
                                        style={{ width: '100%' }}
                                        onChange={(event) => {
                                            setAreaState(event.value)
                                            setAreaCity('')
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="Select State"
                                    />
                                )}</Field>
                            </div> */}
                            {/* <div className='inputContainerDiv' style={{ width: '25%', margin: '0.5rem 0.5rem' }}>
                                {City.getCitiesOfState('US', areaState).length > 0 ? <Field
                                    name={`areaCity`}
                                >{({ field }) => (
                                    <Dropdown
                                        id={field.name}
                                        value={areaCity}
                                        options={City.getCitiesOfState('US', areaState)?.map((state) => ({
                                            label: state.name,
                                            value: state.name,
                                        })) || []}
                                        style={{ width: '100%' }}
                                        onChange={(event) => {
                                            setAreaCity(event.value)
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="Select City"
                                    />
                                )}</Field> : <Field placeholder='Enter City' type="text" id="areaCity" name="areaCity" value={areaCity} onChange={(event) => {
                                    setAreaCity(event.target.value)
                                }} as={InputText} style={{ width: '100%' }} onBlur={handleBlur} />}
                            </div> */}
                            {/* <div style={{ textAlign: 'center', margin: '0.5rem 0.5rem' }}>
                                <Button disabled={areaState ? false : true} type='button' onClick={handleAddClick}>Save</Button>
                            </div> */}
                        </FlexComponent>
                        {/* )}
                         </FieldArray> */}

                        {values.specific_area_interested_in?.length > 1 && <div className='inputContainerDiv' style={{ width: '60%', textAlign: 'start', margin: '0.5rem' }}>
                            <label htmlFor="specific_area_interested_in" >
                                <p >Please Select one area as a priority</p>
                            </label>
                        </div>}

                        <div className='inputContainerDiv' style={{ width: '50%', background: 'white', padding: values?.specific_area_interested_in.length > 0 ? '0.5rem' : '', borderRadius: '10px', margin: '0.5rem' }}>
                            <FieldArray name="specific_area_interested_in">
                                {(arrayHelpers) => (
                                    <>
                                        {values?.specific_area_interested_in?.map((area, index) => {
                                            return (
                                                <FlexComponent justifyContent='start' gap='0.75rem' key={index} style={{ padding: '.75rem', border: "1px solid grey", borderRadius: "5px", marginTop: ".5rem" }}>
                                                    {/* <Field type="radio" id={area.state} name={`specific_area_interested_in[${index}].priority`} value={area.state} as={RadioButton} />
                                                    <label htmlFor={area.state} className="ml-2"><span>{area.state}, {area.city} </span></label> */}
                                                    <FlexComponent justifyContent='start' gap='0.75rem' key={index} >
                                                        {values.specific_area_interested_in?.length > 1 && <Field
                                                            type="checkbox"
                                                            id={area.priority}
                                                            name="home_type"
                                                            value={area.priority}
                                                            as={Checkbox}
                                                            checked={area.priority}
                                                            onChange={(event) => {
                                                                values.specific_area_interested_in?.map((option, ind) => {
                                                                    if (ind == index) {
                                                                        handleChange({ target: { name: `specific_area_interested_in[${ind}].priority`, value: true } });
                                                                    } else {
                                                                        handleChange({ target: { name: `specific_area_interested_in[${ind}].priority`, value: false } });
                                                                    }
                                                                })
                                                            }}
                                                        />}
                                                        <label htmlFor={`area-${index}`} className="ml-2">{[area.street_address, area.city, area.state].filter(Boolean).join(', ')}</label>
                                                    </FlexComponent>
                                                    <Button type='button' style={{ margin: '0 1rem', padding: '.5rem' }} onClick={() => {
                                                        arrayHelpers.remove(index);
                                                        if (values.specific_area_interested_in.length != 1 && values.specific_area_interested_in[index].priority) {
                                                            handleChange({ target: { name: `specific_area_interested_in[${0}].priority`, value: true } });
                                                        }
                                                    }}><i className="pi pi-trash" style={{ fontSize: '1rem' }}></i></Button>
                                                </FlexComponent >
                                            );
                                        })}

                                    </>
                                )}
                            </FieldArray>
                        </div>

                    </div>
                </FlexComponent>

                <div style={{ textAlign: 'start', margin: '0.5rem' }}>

                    <Field rows={4} type="text" placeholder="Notes about home search" id="notes_about_home_search" name="notes_about_home_search" as={InputTextarea} style={{ width: '100%' }} />
                </div>
            </div>
        </div>
    )
}

export default WhatTypeOfHome